module.exports = __webpack_public_path__ + "img/icontype1.5bc7ead5.png";